import { FC, HTMLAttributes } from 'react'
import styles from 'components/features/coaching/advisorMeeting/PaneNote/PaneNote.styl'
import cn from 'classnames'

type PaneNoteProps =
  & HTMLAttributes<HTMLDivElement>
  & {
  }
export const PaneNote: FC<PaneNoteProps> = (props) => {
  const { children, className, ...restProps } = props
  return (
    <div className={ cn(styles.paneNote, className) } { ...restProps }>
      { children }
    </div>
  )
}
